import styled from 'styled-components';

export const Container = styled.li`
  list-style: none;

  .tool-item {
    text-decoration: none;
    cursor: pointer;
  }

  /* Reset mínimo do <button>: padding/largura ficam com as classes de
     variante (row/chip), que têm especificidade menor e perderiam aqui. */
  button.tool-item {
    background: transparent;
    border: none;
    font: inherit;
    text-align: left;
  }

  .tool-item--row {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 7px 8px;
    border-radius: 8px;
    color: #3a475c;

    svg {
      color: #1b9e8d;
      flex-shrink: 0;
    }

    .name {
      font-size: 14px;
      line-height: 1.3;
    }

    &:hover {
      background: #f3f6fb;
      text-decoration: none;
      color: #3a475c;
    }

    @media only screen and (max-width: 768px) {
      padding: 9px 8px;
    }
  }

  .tool-item--chip {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 6px 13px;
    border: 1px solid #e3e8f0;
    border-radius: 20px;
    color: #37445a;
    width: auto;

    svg {
      color: #9aa3b2;
      flex-shrink: 0;
    }

    .name {
      font-size: 13px;
      white-space: nowrap;
    }

    &:hover {
      border-color: #1b9e8d;
      color: #1b9e8d;
      text-decoration: none;

      svg {
        color: #1b9e8d;
      }
    }
  }

  /* Defesa: o header de representante pinta todo <button> do Nav com
     !important (header/styles.ts); os itens-botão precisam se defender. */
  &&& button.tool-item {
    background: transparent !important;
  }

  &&& .tool-item--row:hover {
    background: #f3f6fb !important;
  }

  .tag-new {
    background: #fdecec;
    color: #e5484d;
    font-size: 10px;
    font-weight: 800;
    padding: 2px 7px;
    border-radius: 20px;
    letter-spacing: 0.03em;
    flex-shrink: 0;
  }
`;
